import NProgress from "nprogress";
import "nprogress/nprogress.css";

NProgress.configure({
  showSpinner: false,
  trickleSpeed: 200,
  minimum: 0.08,
});

if (typeof document !== "undefined") {
  const style = document.createElement("style");
  style.setAttribute("data-nprogress-theme", "qms");
  style.textContent = `
    #nprogress .bar {
      background: hsl(221.2, 83.2%, 53.3%) !important;
      height: 3px !important;
    }
    #nprogress .peg {
      box-shadow: 0 0 10px hsl(221.2, 83.2%, 53.3%), 0 0 5px hsl(221.2, 83.2%, 53.3%) !important;
    }
    .dark #nprogress .bar {
      background: hsl(210, 40%, 88%) !important;
    }
    .dark #nprogress .peg {
      box-shadow: 0 0 10px hsl(210, 40%, 88%), 0 0 5px hsl(210, 40%, 88%) !important;
    }
  `;
  document.head.appendChild(style);
}

let depth = 0;

export function pushGlobalLoading() {
  depth += 1;
  if (depth === 1) {
    NProgress.start();
  }
}

export function popGlobalLoading() {
  depth = Math.max(0, depth - 1);
  if (depth === 0) {
    NProgress.done();
  }
}

export function resetGlobalLoadingDepth() {
  depth = 0;
  NProgress.done();
}

export { NProgress };
